import { useEffect, useState } from "react";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import { EvaluationTable } from "../../../core/data/interface"; //Les types des colones de notre tableau déclaré au préalable
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { Link } from "react-router";
import { AxiosError } from "axios";
import Table from "../../../core/common/dataTable/index";
import { toast } from "sonner";
import {
  deleteEvaluation,
  getAllEvaluationByPeriodAndLevel,
} from "../../../api/evaluations";
import { getAllLevel } from "../../../api/pedagogicElement";
import { getAllEvaluationPeriodByLevel } from "../../../api/generalParam";

import CreateEvaluationModal from "./createEvaluationModal";
import EditEvaluationModal from "./editEvaluationModal";
import MissionRepairer from "./missionRepairer";
import InfosAlertYearDisabled from "../../../core/common/alerts/infosAlertYearDisabled";
import withPermission from "../../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  buildPermissionContext,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";

// boutton protégée pour créer une évaluation
const ProtectedBtnAddEvaluation = withPermission(
  (props: any) => (
    <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
      {/* <TooltipOption/> */}
      <div className="mb-2">
        <button
          onClick={() => {
            props.setShowCreate(true);
          }}
          //   to="#"
          // disabled={!selectedYear?.statut}
          className="btn btn-primary d-flex align-items-center"
        >
          <i className="ti ti-square-rounded-plus me-2" />
          Nouvelle Evaluation
        </button>
      </div>
    </div>
  ),
  [buildPermission(Resource.EVALUATION, Action.CREATE)],

  "masquer",
);

// boutton protégée pour modifier une évaluation
const ProtectedBtnUpdateEvaluation = withPermission(
  (props: any) => (
    <li>
      <button
        className="dropdown-item rounded-1"
        // to="#"
        onClick={() => {
          props.setEditEvaluation(props.record.id);
          props.setShowEdit(true);
        }}
        // disabled={!props.selectedYear?.statut}
      >
        <i className="ti ti-edit-circle me-2" />
        Modifier
      </button>
    </li>
  ),
  [buildPermission(Resource.EVALUATION, Action.UPDATE)],
  "masquer",
);

// boutton protégée pour les missions réparatrices
const ProtectedBtnMissionRepairer = withPermission(
  (props: any) => (
    <li>
      <Link
        className="dropdown-item rounded-1"
        to="#"
        onClick={() => {
          // console.log("data send: ", record);

          props.setEditEvaluation(props.record.id);
          props.setEditMissionRepairer(props.record?.missions_reparatrices);
          props.setShowEditMissionRepairer(true);
        }}
      >
        <i className="ti ti-edit-circle me-2" />
        Missions Réparatrices
      </Link>
    </li>
  ),
  [buildPermission(Resource.EVALUATION, Action.UPDATE)],
  "masquer",
);

// boutton protégée pour supprimer une evaluation
const ProtectedBtnDeleteEvaluation = withPermission(
  (props: any) => (
    <li>
      <button
        onClick={() => props.showConfirmationAlert(props.record)}
        className="dropdown-item rounded-1"
        // to="#"
        // disabled={!props.selectedYear?.statut}
      >
        <i className="ti ti-trash-x me-2" />
        Supprimer
      </button>
    </li>
  ),
  [buildPermission(Resource.EVALUATION, Action.DELETE)],
  "masquer",
);

const EvaluationList = () => {
  const { selectedYear } = useAcademicYear();

  //Initialisation des state utilisés
  const [allLevel, setAllLevel] = useState<any[]>([]);
  const [selectedLevel, setSelectedLevel] = useState<any>();

  const [allPeriod, setAllPeriod] = useState<any[]>([]);
  const [selectedPeriod, setSelectedPeriod] = useState<any>();

  const [allEvaluation, setAllEvaluation] = useState([]);
  const [editEvaluation, setEditEvaluation] = useState("");
  const [editMissionRepairer, setEditMissionRepairer] = useState<any[]>([]);

  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données

  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showEditMissionRepairer, setShowEditMissionRepairer] = useState(false);

  const [refreshKey, setRefreshKey] = useState(0);
  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  // Les colonnes de notre tableau
  const columns = [
    {
      title: "Libellé",
      dataIndex: "label",
      sorter: (a: EvaluationTable, b: EvaluationTable) =>
        a.label.length - b.label.length,
    },
    {
      title: "Abréviation",
      dataIndex: "abbreviation",
      sorter: (a: EvaluationTable, b: EvaluationTable) =>
        a.abbreviation.length - b.abbreviation.length,
    },
    {
      title: "Session",
      dataIndex: "session",
      sorter: (a: EvaluationTable, b: EvaluationTable) =>
        a.session.length - b.session.length,
    },
    {
      title: "Catégorie",
      dataIndex: "typeNote",
      sorter: (a: EvaluationTable, b: EvaluationTable) =>
        a.typeNote.length - b.typeNote.length,
    },
    {
      title: "Date de création",
      dataIndex: "createdAt",
      render: (date: string) => {
        const d = new Date(date);
        return d.toLocaleDateString("fr-FR", {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
      sorter: (a: EvaluationTable, b: EvaluationTable) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    },
    {
      title: "action",
      dataIndex: "action",
      render: (_: any, record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                {/* les missions réparatrices */}
                <ProtectedBtnMissionRepairer
                  setEditEvaluation={setEditEvaluation}
                  setEditMissionRepairer={setEditMissionRepairer}
                  setShowEditMissionRepairer={setShowEditMissionRepairer}
                  record={record}
                />

                {/* modifier une évaluation */}
                <ProtectedBtnUpdateEvaluation
                  setEditEvaluation={setEditEvaluation}
                  record={record}
                  setShowEdit={setShowEdit}
                />

                {/* supprimer une évaluation */}
                <ProtectedBtnDeleteEvaluation
                  showConfirmationAlert={showConfirmationAlert}
                  record={record}
                  selectedYear={selectedYear}
                />
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];

  //Traitement en alert de la demande de suppression de l'évaluation
  const showConfirmationAlert = (evaluation: any) => {
    MySwal.fire({
      title: "Supprimer une evaluation ?",
      text: `Souhaitez-vous vraiment supprimer l'évaluation ${evaluation?.label} ?`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête de supression d'une évaluation
          await deleteEvaluation(evaluation?.id);
          MySwal.fire({
            title: "Evaluation supprimée avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });

          fetchEvaluationData();
        } catch (error) {
          const err = error as AxiosError<any>;
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text: err.response?.data?.message || err.response?.data?.error,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  // fonction pour récupérer les classes
  const fetchLevelData = async () => {
    try {
      if (!selectedYear?.id) {
        setAllEvaluation([]);
        return;
      }
      const response = await getAllLevel(
        selectedYear?.id,
        buildPermissionContext(Resource.EVALUATION, Action.READ),
      );
      setAllLevel(response.data);
      // si le tableau de class n'est pas vide sélectionné le 1 er élément par défaut
      setSelectedLevel(
        response.data?.length > 0 ? response.data[0] : undefined,
      );
    } catch (error: any) {
      // console.log("erreur récupération des classes: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // fonction pour récupérer les périodes
  const fetchAllEvaluationPeriod = async () => {
    try {
      if (!selectedLevel?.id) {
        setAllEvaluation([]);
        setAllPeriod([]);
        return;
      }
      const response = await getAllEvaluationPeriodByLevel(
        selectedLevel?.id,
        buildPermissionContext(Resource.EVALUATION, Action.READ),
      );
      // console.log("all period by level: ", response.data);
      setAllPeriod(response.data);
      setSelectedPeriod(
        response.data?.length > 0 ? response.data[0] : undefined,
      );
    } catch (error: any) {
      // console.log("erreur récupération des périodes d'évaluations: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // fonction pour récupérer les évaluations
  const fetchEvaluationData = async () => {
    try {
      if (!selectedLevel?.id || !selectedPeriod?.id) {
        setAllEvaluation([]);
        setIsLoading(false);
        setHasLoaded(true);
        return;
      }
      const response = await getAllEvaluationByPeriodAndLevel(
        selectedLevel?.id,
        selectedPeriod?.id,
      );
      const formattedData = response.data.map((evaluationItem: any) => ({
        ...evaluationItem,
        Level: { id: selectedLevel?.id, label: selectedLevel?.label },
        Period: { id: selectedPeriod?.id, label: selectedPeriod?.label },
      }));
      // console.log("all évaluation by class and period: ", formattedData);
      setAllEvaluation(formattedData);
      setIsLoading(false); //Les données ne sont plus en chargement
      setHasLoaded(true); //Les données ont été chargé avec succès
    } catch (error: any) {
      // console.log("errur récupération des évaluations: ", error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          error.message ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  // on récupère la liste des classes en utilisant sa fonction
  useEffect(() => {
    fetchLevelData();
  }, [selectedYear]);

  // on récupère la liste des périodes d'évaluations en utilisant sa fonction
  useEffect(() => {
    fetchAllEvaluationPeriod();
  }, [selectedLevel]);

  // on récupère la liste des évaluations en utilisant sa fonction
  useEffect(() => {
    fetchEvaluationData();
  }, [selectedPeriod]);

  useEffect(() => {
    if (
      selectedPeriod &&
      !allPeriod.some((period) => period.value === selectedPeriod.value)
    ) {
      // La période sélectionnée ne fait plus partie des options disponibles
      setSelectedPeriod(undefined);
    }
  }, [allPeriod]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Gestion des Evaluations </h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="#">Éléments Pédagogiques</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Evaluations
                  </li>
                </ol>
              </nav>
            </div>
            {/* Boutton en entête de la page */}
            <ProtectedBtnAddEvaluation setShowCreate={setShowCreate} />
          </div>
          {/* /Page Header */}
          {!selectedYear?.statut && <InfosAlertYearDisabled />}
          {/* Tableau liste des évaluations */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Liste des Evaluations</h4>
              <div className="d-flex mb-3 gap-4">
                {/* Niveau */}
                <select
                  className="form-select select"
                  value={selectedLevel?.id ?? ""}
                  onChange={(e) => {
                    const selected = allLevel.find(
                      (opt) => opt.id === e.target.value,
                    );
                    setSelectedLevel(selected);
                  }}
                >
                  <option value="">Sélectionner</option>
                  {allLevel.map((level) => (
                    <option key={level.id} value={level.id}>
                      {level.label}
                    </option>
                  ))}
                </select>

                {/* Période */}
                <select
                  className="form-select select"
                  value={selectedPeriod?.id ?? ""}
                  onChange={(e) => {
                    console.log("periode choisie ?: ", e);
                    const selected = allPeriod.find(
                      (opt) => opt.id === e.target.value,
                    );
                    setSelectedPeriod(selected);
                  }}
                >
                  <option value="">Sélectionner</option>
                  {allPeriod.map((period) => (
                    <option key={period.id} value={period.id}>
                      {period.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Evaluations List (On affiche le tableau qui si les données son chargées même vide) */}
              {isLoading && !hasLoaded ? (
                <div className="text-center">
                  <div className="spinner-border" role="status"></div>
                  <span className="visually">Chargement des Données...</span>
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={allEvaluation}
                  Selection={true}
                />
              )}
              {/* /Evaluations List */}
            </div>
          </div>
        </div>
      </div>
      {/* Modal pour créer une évaluation */}
      <CreateEvaluationModal
        show={showCreate}
        onClose={() => {
          setShowCreate(false);
        }}
        onSaved={() => fetchEvaluationData()}
        metaData={{
          id_level: selectedLevel?.id,
          id_evaluationPeriod: selectedPeriod?.id,
        }}
      />
      {/* Modal pour modiier une évaluation */}
      <EditEvaluationModal
        show={showEdit}
        onClose={() => {
          setShowEdit(false);
        }}
        onSaved={() => fetchEvaluationData()}
        metaData={{
          id_level: selectedLevel?.id,
          id_evaluationPeriod: selectedPeriod?.id,
        }}
        evaluationID={editEvaluation}
      />

      {/* Modal pour la gestion des missions réparatrices */}
      <MissionRepairer
        show={showEditMissionRepairer}
        onClose={() => {
          setShowEditMissionRepairer(false);
        }}
        metaData={{
          id_level: selectedLevel?.id,
          id_evaluationPeriod: selectedPeriod?.id,
          all_evaluation: allEvaluation,
          mission_repairer: editMissionRepairer,
        }}
        evaluationID={editEvaluation}
        onSaved={() => fetchEvaluationData()}
      />
    </>
  );
};

export default EvaluationList;
